import { useState } from "react";
import { useDispatch } from "react-redux";
import { postKjoretoyMerke } from "../../../actions/kjoretoyMerkerActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../utils/validationUtils";
import ModalGeneric from "../../Common/ModalGeneric";
import KjoretoyMerkerForm from "../KjoretoyMerkerForm";
import OpenModalComponent from "./OpenModalComponent";

const rules = {
  kode: "required;minLength=1;maxLength=50",
  merke: "required;minLength=3;maxLength=50",
};

const initState = () => ({
  open: false,
  submitButtonText: "Legg til ny",
  kode: "",
  merke: "",
  validationError: {},
});

export default function KjoretoyMerkerModal() {
  const dispatch = useDispatch();
  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  const closeModal = () => setState(initState());

  const isFormValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePost = () => {
    update({ submitButtonText: "Legger til..." });
    dispatch(postKjoretoyMerke({ kode: state.kode, merke: state.merke }))
      .then(closeModal)
      .catch(() => update({ submitButtonText: "Legg til ny" }));
  };

  const saveAndClose = () => {
    if (isFormValid()) handlePost();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const draft = { ...state, [name]: value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <ModalGeneric
      modalTitle="Legg til nytt kjøretøymerke"
      open={state.open}
      closeModal={closeModal}
      openModal={() => update({ open: true })}
      OpenModalComponent={OpenModalComponent}
      submit={saveAndClose}
      submitButtonText={state.submitButtonText}
    >
      <KjoretoyMerkerForm
        kode={state.kode}
        merke={state.merke}
        validationError={state.validationError}
        handleChange={handleChange}
      />
    </ModalGeneric>
  );
}
